// Assets/custom-video-autoplay.js
document.addEventListener('DOMContentLoaded', () => {
  const clickDeferredButtons = () => {
    // Horizon/Dawn-style deferred media wrappers
    document.querySelectorAll('deferred-media button, .deferred-media button').forEach(btn => {
      if (!btn.dataset.autoplayInit) {
        btn.dataset.autoplayInit = '1';
        btn.click(); // mounts the <video> into the DOM
      }
    });
  };

  const enableAutoplay = () => {
    const prep = v => {
      if (!v) return;
      // required for mobile autoplay
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('autoplay', '');
      // nice-to-have for short clips
      v.loop = true;
      v.preload = 'metadata';
      // kick playback
      const p = v.play && v.play();
      if (p && p.catch) p.catch(() => {}); // ignore if browser blocks
    };

    document.querySelectorAll(
      'product-media video, .product__media video, .product-media video, video'
    ).forEach(prep);
  };

  // Initial pass
  clickDeferredButtons();
  enableAutoplay();

  // Re-run if variants/media swap in later
  const mo = new MutationObserver(() => {
    clickDeferredButtons();
    enableAutoplay();
  });
  mo.observe(document.body, { childList: true, subtree: true });
});
